import React from "react"

const RyderLivescoringTournamentHeaderDefaultView = ({
    competition,
    teams,
    teamIds,
    isGroupingView
}) => {
    const [invalidTeamImageMap, setInvalidTeamImageMap] = React.useState({})

    return (
        <div className="mb-2 h-full rounded-lg bg-white px-4 py-2 w-full max-w-7xl mx-auto shadow-md space-y-6 container-marker-header">
            {
                !isGroupingView &&
                <div className={`flex flex-col-reverse w-full max-w-7xl mx-auto mb-1 sm:mb-4 sm:flex-row items-center justify-between min-w-0 lg:flex-col-reverse lg:items-center xl:items-center 2xl:items-center lg:mb-10`}>
                    <div className="flex flex-col-reverse">
                        <h2 className="text-sm text-slate-300 text-center sm:text-left lg:text-center sm:text-base lg:text-sm xl:text-base 2xl:text-lg font-semibold uppercase tracking-tight m-1 sm:m-0 sm:mb-2">
                            {competition.organiserName}
                        </h2>
                        <h1 className="text-2xl text-slate-600 text-center sm:text-left lg:text-center sm:text-2xl lg:text-lg xl:text-2xl 2xl:text-3xl font-bold uppercase tracking-tight m-1 sm:m-0 lg:mt-6 pb-2">
                            {competition.name}
                        </h1>
                    </div>
                    <img
                        className="h-6 sm:h-6 m-2 lg:mt-3 lg:block lg:mx-auto lg:h-7 xl:h-9 2xl:h-9 opacity-30"
                        src="https://assets.codepen.io/261257/LOGO_SIMPLE_2023_72_LS.svg"
                        alt="Logo nxt"
                    />
                </div>
            }

            <div className="w-full max-w-7xl mx-auto overflow-hidden rounded-lg sm:mb-0">
                <div className={`flex flex-col gap-4 sm:gap-8 sm:flex-row lg:gap-6 lg:flex-col`}>
                    {teamIds.map((teamId, idx) => {
                        const teamImageUrl = teams[teamId].imageUrl
                        const teamImageKey = `${teamId}-${teamImageUrl || ""}`
                        const showTeamImage = Boolean(teamImageUrl) && !invalidTeamImageMap[teamImageKey]

                        const classes = [
                            "flex-1 min-w-0 flex items-center justify-between px-2 py-1.5 rounded-lg flex-row",
                            "flex-row",
                            idx === 1 && "flex-row-reverse lg:flex-row",
                            `team-header-${teams[teamId].color}`,
                        ]
                            .filter(Boolean)
                            .join(" ")

                        const imageAndNameRowClasses = [
                            "flex-1 min-w-0 flex items-center flex-row",
                            "flex-row",
                            idx === 1 && "flex-row-reverse lg:flex-row",
                        ]
                            .filter(Boolean)
                            .join(" ");

                        return (
                            <div key={teamId} className={classes}>
                                <div className={imageAndNameRowClasses}>
                                    {showTeamImage && (
                                        <div className="w-16 h-13 lg:w-20 lg:h-20 xl:w-24 xl:h-24 rounded-sm overflow-hidden team-logo-container">
                                            <img
                                                src={teamImageUrl}
                                                alt={teams[teamId].name}
                                                className="object-cover team-logo"
                                                onError={() => {
                                                    setInvalidTeamImageMap((prevState) => ({
                                                        ...prevState,
                                                        [teamImageKey]: true
                                                    }))
                                                }}
                                            />
                                        </div>
                                    )}
                                    <h2 className="text-lg font-semibold m-2 xl:text-xl 2xl:text-2xl team-name">
                                        {teams[teamId].name}
                                    </h2>
                                </div>
                                <div className="text-3xl sm:text-3xl lg:py-1 xl:text-3xl 2xl:text-4xl font-bold m-2 general-points">
                                    {teams[teamId].score.general}
                                    <span className="ups-points">{teams[teamId].score.ups} UPS</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    )
}

export default RyderLivescoringTournamentHeaderDefaultView
